export default {
  IS_REQUIRED: 'required',
  DOES_NOT_MATCH_PATTERN: 'pattern',
  BLOCKED: 'blocked',
  LENGTH: 'length'
};
